module.exports = __webpack_public_path__ + "static/media/4.7d762ca8.JPG";